import { captureException } from "@sentry/nextjs";
import { z } from "zod";

export function isSuccess<T>(result: { success: boolean; data?: T }): result is { success: true; data: T } {
  return result.success;
}

export function validateData<T>(schema: z.ZodSchema<T>, data: unknown) {
  const result = schema.safeParse(data);

  if (!result.success) {
    throw new Error(result.error.errors[0].message);
  }

  return result.data;
}

// Theo's custom try-catch wrapper function
type Success<T> = {
  data: T;
  error: null;
};

type Failure<E> = {
  data: null;
  error: E;
};

type Result<T, E = Error> = Success<T> | Failure<E>;

export async function tryCatch<T, E = Error>(promise: Promise<T>): Promise<Result<T, E>> {
  try {
    const data = await promise;

    return { data, error: null };
  } catch (error) {
    console.error(error);
    captureException(error);

    return { data: null, error: error as E };
  }
}

// Recycled

// export function validateData<TSchema extends z.ZodSchema>(schema: TSchema, data: unknown): ValidateResponse<z.infer<TSchema>> (easy to understand)
